import McElement from "https://gipys.it/cdn/shop/t/11/assets/mc-element.js?v=90842969451512648831772093217";
import Swiper from "https://gipys.it/cdn/shop/t/11/assets/swiper.js?v=48144671975511222411769170964";
class McSwiper extends McElement {
  constructor() {
    super(...arguments);
    this.options = {};
    this.init = () => {
      Object.entries(this.dataset).forEach(([key, value]) => {
        if (key === "log") return;
        this.options = this.process(this.options, key, value);
      });
      this.adjustOptions();
      this.events();
      this.swiper = new Swiper(this, this.options);
      this.log("Inizializzato Swiper.js", this.options);
    };
    this.adjustOptions = () => {
      if (this.options.navigation === true) {
        this.options.navigation = { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" };
      }
      if (this.options.pagination === true) {
        this.options.pagination = { el: ".swiper-pagination" };
      }
      if (this.options.scrollbar === true) {
        this.options.scrollbar = { el: ".swiper-scrollbar" };
      }
      if (this.options.navigation && this.options.navigation.nextEl === void 0) {
        this.options.navigation.nextEl = ".swiper-button-next";
      }
      if (this.options.navigation && this.options.navigation.prevEl === void 0) {
        this.options.navigation.prevEl = ".swiper-button-prev";
      }
      if (this.options.pagination && this.options.pagination.el === void 0) {
        this.options.pagination.el = ".swiper-pagination";
      }
      if (this.options.scrollbar && this.options.scrollbar.el === void 0) {
        this.options.scrollbar.el = ".swiper-scrollbar";
      }
      if (this.options.resizeObserver === void 0) {
        this.options.resizeObserver = true;
      }
    };
    this.events = () => {
      if (this.dataset.autoplayProgress != void 0 && this.options.autoplay && this.options.autoplay.delay > 0) {
        this.log("Abilitata barra di progresso autoplay");
        this.options.on = this.options.on || {};
        const delay = this.options.autoplay.delay;
        this.options.on.autoplayTimeLeft = (s, time, progress) => {
          const percentage = (1 - progress) * 100;
          this.style.setProperty("--progress", `${percentage}%`);
        };
      }
    };
    this.process = (options, key, value) => {
      const parts = key.split(".");
      const option = isNaN(Number(parts[0])) ? parts[0] : Number(parts[0]);
      if (!option) {
        this.log(`Opzione non valida: ${key}`);
        return options;
      }
      if (parts.length > 1) {
        if (typeof options[option] !== "object") {
          options[option] = {};
        }
        options[option] = this.process(options[option] || {}, parts.slice(1).join("."), value);
        return options;
      }
      const v = !value || value === "true" || value == "" ? true : isNaN(Number(value)) ? value === "false" ? false : value : Number(value);
      options[option] = v;
      this.log(`Impostata opzione: ${option} = ${v}`);
      return options;
    };
  }
  connectedCallback() {
    super.connectedCallback();
    this.init();
  }
}
if (!customElements.get("mc-swiper"))
  customElements.define("mc-swiper", McSwiper);
var mc_swiper_default = McSwiper;
export {
  mc_swiper_default as default
};
